import { useDealContext } from '../../../utils/context/DealContext';

import { DealForecastBidGuidance } from './DealForecastBidGuidance';
import { DealForecastMetrics } from './DealForecastMetrics';
import { TopMarketRequests } from './TopMarketRequests/TopMarketRequests';
import { UnforecastedTargetingVariables } from './UnforecastedTargetingVariables/UnforecastedTargetingVariables';
import { UnusedParams } from './UnusedParams/UnusedParams';

type DealForecastContentProps = {
  loading: boolean;
  job_id: string;
};

export const DealForecastContent = ({ loading, job_id }: DealForecastContentProps) => {
  const { useFetchDealForecast } = useDealContext();

  useFetchDealForecast(job_id);

  if (loading) {
    return null;
  }

  return (
    <>
      <UnusedParams />
      <DealForecastMetrics />
      <DealForecastBidGuidance />
      <TopMarketRequests />
      <UnforecastedTargetingVariables />
    </>
  );
};
